import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogData } from 'listing-angular15';
import { CookieService } from 'ngx-cookie-service';
import { ConfarenceRoomLinkComponent } from 'src/app/astrologer-dashboard/main/ConfarenceRoomDialog/confarence-room-link/confarence-room-link.component';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { SharedModule } from 'src/app/shared/shared.module';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent {
  public progressLoader: boolean = false;
  public datasource: any;
  tabledata_header_skip: any = ["_id"];
  tabledata_detail_skip: any = ['_id', 'usertype'];
  public tabledatatalist: any = [];
  updatetable: boolean = false;
  tablename = "users";
  editroute = "";
  updateendpoint = "user/status-change";
  deleteendpoint = "user/delete-user";
  datacollection: any = "user/user-list";
  public listprogressBar: any = false;

  searchendpoint = "";
  date_search_endpoint: any = "";
  date_search_source: any = "users";
  date_search_source_count: any = 0;
  Tabledata_header_skip: any = ["_id"];
  limitcond: any = {
    limit: 10,
    skip: 0,
    pagecount: 1,
  };
  statusarray: any = [
    { val: 1, name: "Active" },
    { val: 0, name: "Inactive" },
  ];
  rolearray: any = []
  // packagarray: any = []
  // [
  //   {
  //     val: {
  //       is_admin: 1
  //     }, name: "Admin"
  //   },
  //   {
  //     val: {
  //       is_astrologer: 1
  //     }, name: "Astrologer"
  //   },
  //   {
  //     val: {
  //       is_tarotreader: 1
  //     }, name: "Tarotreader"
  //   },
  //   {
  //     val: {
  //       is_social_advo: 1
  //     }, name: "Social Advo"
  //   },
  // ];

  modify_header_array: any = {
    name: "Name",
    // lastname: "Last Name",
    role: "Role",
    email: "Email",
    phone: "Phone",
    status: "Status",
    created_at: "Joined on",
    last_login_time: "Last Login Time",
  };


  search_settings: any = {

    // search: [{
    //   label: "Search By Name", field: '_id',
    //   serversearchdata: { endpoint: 'intake/assayautocomplete' },
    // },
    // ],

    datesearch: [
      {
        startdatelabel: 'Joined on Start Date',
        enddatelabel: 'Joined on End Date',
        submit: 'Search',
        field: 'created_at',
        // value: {$gte: created_at, $lte: 1622962799000}
      },
      // {
      //   startdatelabel: 'Last Login Time Start Date',
      //   enddatelabel: 'Last Login Time End Date',
      //   submit: 'Search',
      //   field: 'last_login_time',
      //   // value: {$gte: created_at, $lte: 1622962799000}
      // },


    ],
    textsearch: [
      {
        label: "Search By Name", field: 'name',
      },
      {
        label: "Search By Email", field: 'email',
      }
    ],

    selectsearch: [
      { label: 'Search By Role', field: 'user_type', values: this.rolearray },
      { label: 'Search By Status', field: 'status', values: this.statusarray },

    ],
  }
  sortdata: any = {
    type: "desc",
    field: "_id",
    options: ["name", "created_at", "created_at", "role", "email", "status", "usertype", "last_login_time"],
  };
  public cookieData: any = {};
  public userName: any = {};
  public lastLogin: any = {};
  public isAdminUser: boolean = false;
  public isDoctorUser: boolean = false;

  public customlistenbutton: any = {
    flag: true,
    tooltipflag: true,
    buttons: [
      // {
      //   label: 'Add Assay',
      //   type: 'button',
      //   name: 'add_taxonomies',
      //   tooltip: 'Add Taxonomies',
      //   classname: 'add_adminBTN',
      // },
    ],
  }
  libdata: any = {
    basecondition: {},

    detailview_override: [
      { key: "name", val: "Name" },
      { key: "firstname", val: "First Name" },
      { key: "lastname", val: "lastname" },
      { key: "role", val: "role" },
      { key: "email", val: "Email" },
      { key: "phone", val: "Phone" },
      { key: "state", val: "State" },
      { key: "city", val: "City" },
      { key: "notescount", val: "Notes" },
      { key: "zip", val: "Zip" },
      { key: "additional_info", val: "Additional Info" },
      { key: "package_names", val: "Package Names" },
      { key: "status", val: 'Status' }
    ],
    updateendpoint: "user/status-change",

    hidedeletebutton: false,
    hideviewbutton: true,
    hideeditbutton: true,
    hidestatustogglebutton: false,
    hidemultipleselectbutton: false,
    hideaction: false,
    updateendpointmany: "user/status-change",

    deleteendpointmany: "user/delete-user",
    tableheaders: ["name", "role", "email", "phone", "created_at", "last_login_time", "status"],

    colpipes: [
      { type: 'datetime', col: 'last_login_time', format: 'MMMM D YYYY, h:mm A' },
      { type: 'datetime', col: 'created_at', format: 'MMMM D YYYY, h:mm A' },
    ],


    custombuttons: [
      {
        label: "Edit",
        type: 'listner',
        id: 'edit_btn',
        tooltip: 'Edit',
        name: 'edit',
        classname: 'edit_btn'
      },

      {
        label: "package",
        type: 'listner',
        id: 'package_btn',
        tooltip: 'Assign Packages',
        cond: "showCustomerBtn",
        condval: 1,
        name: 'package_btn',
        classname: 'package_btn'
      },
      {
        label: "Send mail",
        type: 'listner',
        id: 'sendmail_btn',
        tooltip: 'Send Welcome Mail',
        name: 'sendmail_btn',
        classname: 'sendmail_btn'
      },
      {
        label: "Reset Password",
        type: 'listner',
        id: 'reset_password',
        tooltip: 'Reset Password',
        name: 'reset_password',
        classname: 'reset_password'
      },
      {
        label: "Role",
        type: 'listner',
        id: 'role_btn',
        tooltip: 'Manage Role',
        name: 'edit',
        classname: 'role_btn'
      },

      {
        label: "Preview",
        type: 'action',
        datatype: 'api',
        endpoint: 'user/user-preview',
        otherparam: [],
        // cond:'status',
        // condval:0,
        param: '_id',
        datafields: ['name', 'email', 'phone', 'state', 'city', 'zip', 'additional_info', 'package_names'],
        //  refreshdata: true,
        headermessage: 'Preview',
        tooltip: 'Preview',
        classname: 'previewButton'
      },
      {
        label: "Login Info",
        type: 'listner',
        id: 'login_info_btn',
        tooltip: 'Login Info',
        name: 'logininfo',
        classname: 'login_info_btn'
      },
      {
        label: "Training Settings",
        type: 'listner',
        id: 'training_settings_btn',
        tooltip: 'Training Settings',
        name: 'logininfo',
        classname: 'training_settings_btn'
      },

      {
        label: 'Confarence Room',
        type: 'listner',
        id: 'confarence_room',
        tooltip: 'Share Conference Room Link',
        name: 'Confarence Room',
        classname: 'confarence_room',
        cond: "user_type",
        condval: "is_trainee"
      },

      {
        label: 'Mark as Graduate',
        type: 'listner',
        id: 'mark_as_graduate',
        tooltip: 'Mark as Graduate',
        name: 'mark_as_graduate',
        classname: 'mark_as_graduate',
        cond: "user_type",
        condval: "is_astrologer"
      },
      {
        label: 'Mark as Graduate',
        type: 'listner',
        id: 'mark_as_graduate',
        tooltip: 'Mark as Graduate',
        name: 'mark_as_graduate',
        classname: 'mark_as_graduate',
        cond: "user_type",
        condval: "is_tarotreader"
      },
      {
        label: 'Go to Profile',
        type: 'listner',
        id: 'go_to_profile',
        tooltip: 'Go to Profile',
        name: 'go_to_profile',
        classname: 'go_to_profile',
        cond: "user_type",
        condval: "is_astrologer"
      },
    ],


  }
  public taxonomy_updatetable: boolean = false;
  public api_url_for_managebanner = environment.api_url
  public jwttokenformanagebanner = ''

  constructor(public dialog: MatDialog, public router: Router, public activatedRoute: ActivatedRoute, private _bottomSheet: MatBottomSheet, public cookieService: CookieService, private apiservice: ApiservicesService, private _snackBar: MatSnackBar, public matSnackBar: MatSnackBar) {
    // this.cookieData = JSON.parse(this.cookieService.getAll()['login_user_details']);
    // if (!window.location.pathname.includes('admin/miscellaneous')) {
    //   this.router.navigateByUrl('404')
    // }

  }

  ngOnInit() {


    this.getRoles()
    // this.packageRoles()
    if (this.cookieService.getAll()['login_user_details']) {
      this.cookieData = JSON.parse(this.cookieService.getAll()['login_user_details']);
      // console.log("cookieData", this.cookieData.userinfo);
      this.userName = this.cookieData.userinfo.name
      this.lastLogin = this.cookieData.userinfo.last_login_time
    }
    //  this.userListFetching()
    // Subscribe to list data fetching
    this.activatedRoute.data.subscribe({
      next: (res: any) => {
        // console.log('List Response/Libdata ----->', res);
        this.tabledatatalist = res?.response?.results?.res && Array.isArray(res.response.results.res) ? res.response.results.res : [];
        this.apiservice.getHttpDataPost(
          'user/user-list-count',
          {
            "condition": {
              "limit": 10,
              "skip": 0,
            },
            "sort": {
              "type": 'desc',
              "field": '_id'
            },
            "searchcondition": {}
          }
        ).subscribe((response: any) => {
          console.log("response======>>>>", response);

          if (response && response.count) {
            this.date_search_source_count = response.count;
          }
        })
      },
      error: (error: any) => {
        console.log('error --------->', error);
      }
    });
    // 

    if (this.cookieData) {
      // console.log("cookieData====>", this.cookieData.userinfo);
      this.libdata.notes = {
        label: "Notes",
        tooltip: 'Add Notes',
        listendpoint: "notes/listnotedata",
        deleteendpoint: "notes/deletenotedata",
        addendpoint: "notes/addnotedata",
        user: this.cookieData.userinfo._id,
        currentuserfullname: this.cookieData.name,
        header: "fullname",
      }

    }
    // console.log("libdata====>>>>", this.libdata);

 
    
  }





  onLiblistingButtonChange(val: any) { }
  listenLiblistingChange(data: any = null) {
    console.log("test", data);
    if (data?.custombuttonclick?.btninfo.id == 'edit_btn') {
      this.editListItem(data.custombuttonclick.data);
    }
    if (data?.custombuttonclick?.btninfo.id == 'sendmail_btn') {
      console.log("send mail data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(WelcomeModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Edit Location Data",
          mailObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });
    }


    if (data?.custombuttonclick?.btninfo.id == 'mark_as_graduate') {
      console.log("send mail data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(MarkAsGraduateModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Mark As Graduate Data",
          markasObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });
    }



    





    if (data?.custombuttonclick?.btninfo.id == 'reset_password') {
      console.log("data.custombuttonclick.data", data.custombuttonclick.data);

      let passwordobj = {
        _id: data.custombuttonclick.data._id
      }
      this.apiservice.getHttpDataPost('user/send-resetpassword-mail', passwordobj).subscribe((response) => {
        console.log("response======++++", response);
        if (response.status == "success") {
          this.matSnackBar.open(response.message, "", {
            duration: 3000
          });
        }

      })
    }

    if (data?.custombuttonclick?.btninfo.id == 'login_info_btn') {
      console.log("data.custombuttonclick.data", data.custombuttonclick.data);

      let logininfodobj = {
        _id: data.custombuttonclick.data._id
      }
      this.apiservice.getHttpDataPost('user/fetch-login-details', logininfodobj).subscribe((response) => {
        console.log("response login info", response);
        if (response.status == "success") {

          const dialogRef = this.dialog.open(LoginInfoModal, {
            panelClass: 'custom-modalbox',
            data: {
              heading: "Edit Location Data",
              loginObj: response
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed');
            this.updatetable = !this.updatetable;
          });
          // this.matSnackBar.open(response.message, "", {
          //   duration: 3000
          // });         
        }

      })
    }

    if (data?.custombuttonclick?.btninfo.id == 'log_me_in_btn') {
      // this.editListItem(data.custombuttonclick.data);
      console.log("role data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(comingsoonModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Edit Location Data",
          roleObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });

    }
    if (data?.custombuttonclick?.btninfo.id == 'folder_view_btn') {
      // this.editListItem(data.custombuttonclick.data);
      console.log("role data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(comingsoonModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Edit Location Data",
          roleObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });

    }
    if (data?.custombuttonclick?.btninfo.id == 'view_customers_btn') {
      // this.editListItem(data.custombuttonclick.data);
      console.log("role data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(comingsoonModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Edit Location Data",
          roleObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });

    }

    if (data?.custombuttonclick?.btninfo.id == 'role_btn') {
      // this.editListItem(data.custombuttonclick.data);
      console.log("role data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(RoleModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Manage Role Data",
          roleObj: data.custombuttonclick.data,
          roleList: this.rolearray
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });

    }

    if (data?.custombuttonclick?.btninfo.id == 'package_btn') {
      // this.editListItem(data.custombuttonclick.data);
      console.log("role data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(packageModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "Edit Location Data",
          roleObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });

    }



    if (data?.custombuttonclick?.btninfo.id == 'training_settings_btn') {
      // this.editListItem(data.custombuttonclick.data);
      // console.log("role data", data.custombuttonclick.data);
      const dialogRef = this.dialog.open(trainingSettingsModal, {
        panelClass: 'custom-modalbox',
        data: {
          heading: "training settings Data",
          trainingObj: data.custombuttonclick.data
        },
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('The dialog was closed');
        this.updatetable = !this.updatetable;
      });

    }

    // ==============================share button for conference room===================
    if (data?.custombuttonclick?.btninfo.id == 'confarence_room') {

      this.cookieData = JSON.parse(this.cookieService.getAll()['login_user_details']);





      const dialogRef = this.dialog.open(ConfarenceRoomLinkComponent, {
        data: {
          log_in_Id: this.cookieData?.userinfo,
          participent_id: data?.custombuttonclick.data,
          room_key: '5m54-i39l-34k2',
          url: environment.confarence_room_base_url
        },
      })
      console.log("hit--------->>>>>>>", data)
      dialogRef.afterClosed().subscribe((result) => { })
    }

    if(data.action === "custombuttonclick" && data.custombuttonclick.btninfo.id === "go_to_profile"){
      let userdata = data.custombuttonclick.data
      this.router.navigateByUrl(`profile/${userdata.user_type}/${userdata._id}`);
    }

  }

  getRoles() {
    this.apiservice.getHttpData('admin/fetch-role-list').subscribe({
      next: (roles) => {
        roles.results.forEach((x: any) => {
          this.rolearray.push({ val: x.slug, name: x.role_name })

        })
      }
    })
  }

  // packageRoles() {
  //   this.apiservice.getHttpData('package/fetch-all-package').subscribe({
  //     next: (packag) => {
  //       packag.results.forEach((x: any) => {
  //         this.packagarray.push({ val: x._id, name: x.name })

  //       })
  //     }
  //   })
  // }


  addBtn() {
    this.router.navigateByUrl(`admin-dashboard/add-user`);
  }

  editListItem(item: any) {
    if (item) {
      // console.log("Op=====>1", item);
      this.router.navigateByUrl(`admin-dashboard/edit-user/${item._id}`);
    }
  }
}


@Component({
  selector: 'rolemodal',
  templateUrl: 'rolemodal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class RoleModal {
  public userformdata: any = {};

  public roleList: any = [];
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false

  constructor(
    public dialogRef: MatDialogRef<RoleModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar
  ) {
    this.modaldata = data
    // console.log(this.modaldata.roleObj.role, "modal data++");
  }

  ngOnInit() {
    this.initailForm();
    // this.getRoles()
    console.log("role modaldata", this.modaldata);

  }


  // getRoles() {
  //   this.apiservice.getHttpData('admin/fetch-role-list').subscribe((response) => {
  //     console.log("Role data", response);

  //     if (response.results && response.results.length > 0) {
  //       response.results.forEach((e: any, i: number) => {
  //         let obj = { val: e.slug, name: e.role_name };
  //         this.roleList.push(obj)
  //       })
  //     }

  //   })
  // }

  initailForm() {


    this.userformdata =
    {
      // from start
      successmessage: 'Added Successfully !!', // success message
      submittext: 'Update',
      apiUrl: this.apiservice.baseUrl,
      // endpoint: 'users/addUpdateData',
      resettext: 'Reset',
      canceltext: 'Cancel',
      hidereset: true,
      hidecancel: true,
      jwttoken: '',
      // cancelroute: `admin/taxonomies/list`, // use for redirect after cancel the form
      fields: [
        {
          label: "User Type",
          name: "user_type",
          type: 'select',
          value: this.modaldata.roleObj.user_type,
          val: this.modaldata.roleList,
          multiple: false,
          validations: [
            { rule: 'required', message: 'User Type is Required' }
          ],

        },


      ]
    }
    // if (this.editFormData) {
    //   console.log("sdfsd")
    //   this.formfieldrefreshdata = {
    //     field: "removefromcontrol",
    //     value: ["password", "confirmpassword"],
    //   };
    //   // this.locationFieldManage(this.editFormData.location)
    // }

  }
  listenFormFieldChange(val: any) {

    if (val.field && val.field == "fromsubmit") {
      this.loader = true
      let dataobj = val.fromval;
      if (dataobj) {
        dataobj.id = this.modaldata.roleObj._id
      }

      this.apiservice.getHttpDataPost('user/user-role-update', dataobj).subscribe((response) => {
        // console.log("dataobj", response)
        if (response && response.status == 'success') {
          this.loader = false
          // console.log("this.loader", this.loader);
          this.matSnackBar.open(response.message, "Ok", {
            duration: 3000
          });
          this.dialogRef.close();
          // this.router.navigateByUrl(`admin-dashboard`);
          // this.addFormLoader = false;
          // this.location.back();
        }

        if (response && response.status == 'error') {
          this.loader = false
          this.matSnackBar.open(response.message, "", {
            duration: 1000
          });
          // this.addFormLoader = false;
        }

      })
    }

  }

  // this.formfieldrefreshdata = {}
}







@Component({
  selector: 'packageModal',
  templateUrl: 'package-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class packageModal {
  public userformdata: any = {};

  public packageList: any = [];
  public packageval: any = [];
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false

  constructor(
    public dialogRef: MatDialogRef<packageModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar
  ) {
    this.modaldata = data
    // console.log(this.modaldata.roleObj.role, "modal data++");
  }

  ngOnInit() {

    this.initailForm();

    if (this.modaldata) {
      this.modaldata.roleObj.package_data.forEach((e: any, i: number) => {
        this.packageval.push(e.val)
      })
    }
    this.getRoles()

    console.log("packageval data", this.packageval);
  }

  getRoles() {
    this.apiservice.getHttpData('package/fetch-all-package').subscribe((response) => {
      if (response.results && response.results.length > 0) {
        response.results.forEach((e: any, i: number) => {
          let obj = { val: e._id, name: e.name };
          this.packageList.push(obj)
        })
      }

    })
  }

  initailForm() {
    this.userformdata =
    {
      // from start
      successmessage: 'Added Successfully !!', // success message
      submittext: 'Update',
      apiUrl: this.apiservice.baseUrl,
      // endpoint: 'users/addUpdateData',
      resettext: 'Reset',
      canceltext: 'Cancel',
      hidereset: true,
      hidecancel: true,
      jwttoken: '',
      // cancelroute: `admin/taxonomies/list`, // use for redirect after cancel the form
      fields: [
        {
          label: "packages",
          name: "package_id",
          type: 'select',
          value: this.packageval,
          val: this.packageList,
          multiple: true,
          validations: [
            { rule: 'required', message: 'User Type is Required' }
          ],

        },


      ]
    }
    // if (this.editFormData) {
    //   console.log("sdfsd")
    //   this.formfieldrefreshdata = {
    //     field: "removefromcontrol",
    //     value: ["password", "confirmpassword"],
    //   };
    //   // this.locationFieldManage(this.editFormData.location)
    // }

  }
  listenFormFieldChange(val: any) {
    if (val.field && val.field == "fromsubmit") {
      this.loader = true
      let dataobj = val.fromval;
      if (dataobj) {
        dataobj.user_id = this.modaldata.roleObj._id
      }

      this.apiservice.getHttpDataPost('subscription/subscribe', dataobj).subscribe((response) => {
        // console.log("dataobj", response)
        if (response && response.status == 'success') {
          this.loader = false
          this.matSnackBar.open(response.message, "Ok", {
            duration: 3000
          });
          this.dialogRef.close();
        }

        if (response && response.status == 'error') {
          this.loader = false
          this.matSnackBar.open(response.message, "", {
            duration: 1000
          });
        }

      })
    }

  }

  // this.formfieldrefreshdata = {}
}



@Component({
  selector: 'coming-soon',
  templateUrl: 'coming-soon.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class comingsoonModal {
  public userformdata: any = {};

  public roleList: any = [];
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false

  constructor(
    public dialogRef: MatDialogRef<comingsoonModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar
  ) {
    this.modaldata = data
    // console.log(this.modaldata.mailObj, "modal data++");
  }

  ngOnInit() {
    // console.log("modaldata mail data", this.modaldata);
  }

  public closeModal() {
    this.dialogRef.close();
  }

}

@Component({
  selector: 'WelcomeModal',
  templateUrl: 'welcomemodal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class WelcomeModal {
  public userformdata: any = {};

  public roleList: any = [];
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false

  constructor(
    public dialogRef: MatDialogRef<WelcomeModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar
  ) {
    this.modaldata = data
    // console.log(this.modaldata.mailObj, "modal data++");
  }

  ngOnInit() {
    // console.log("modaldata mail data", this.modaldata);
  }

  public closeModal() {
    this.dialogRef.close();
  }
  public sendMail() {
    let dataobj = {
      _id: this.modaldata.mailObj._id
    }
    this.apiservice.getHttpDataPost('user/resend-welcome-mail', dataobj).subscribe((response) => {
      // console.log("response======++++", response);
      if (response.status == "success") {
        this.matSnackBar.open(response.message, "", {
          duration: 3000
        });
        this.dialogRef.close();
      }

    })
  }




  // this.formfieldrefreshdata = {}
}


@Component({
  selector: 'WelcomeModal',
  templateUrl: 'login-infomodal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class LoginInfoModal {
  public userformdata: any = {};

  public logininfoList: any = [];
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false
  public loginInfoFlag: boolean = false

  constructor(
    public dialogRef: MatDialogRef<LoginInfoModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar
  ) {
    this.modaldata = data
    // console.log(this.modaldata.loginObj, "modal data++");
  }

  ngOnInit() {
    // console.log("modaldata mail data", this.modaldata);
    if (this.modaldata.loginObj.results && this.modaldata.loginObj.results.length > 0) {
      this.logininfoList = this.modaldata.loginObj.results
      // console.log("modaldata mail data++++++++", this.logininfoList);
    } else {
      this.loginInfoFlag = true
      // console.log("modaldata mail data--------", this.logininfoList);
    }
  }

  public closeModal() {
    this.dialogRef.close();
  }
  // public sendMail(){
  //   let dataobj ={
  //     _id:this.modaldata.mailObj._id
  //   }
  //   this.apiservice.getHttpDataPost('user/resend-welcome-mail', dataobj).subscribe((response) => {
  //     console.log("response======++++", response);
  //     if (response.status=="success") {
  //       this.matSnackBar.open(response.message, "", {
  //         duration: 3000
  //       });
  //       this.dialogRef.close();
  //     }

  //   })
  // }




  // this.formfieldrefreshdata = {}
}


@Component({
  selector: 'training-settings-modal',
  templateUrl: 'training-settings-modal.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class trainingSettingsModal {
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false
  public trainingFlag: boolean = false
  allComplete: boolean = false;
  public trainingsettingsForm: FormGroup;
  public checkdata: any = "";

  constructor(
    public dialogRef: MatDialogRef<trainingSettingsModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar, private _formBuilder: FormBuilder
  ) {
    this.modaldata = data
    // console.log(this.modaldata.mailObj, "modal data++");
    this.trainingsettingsForm = new FormGroup({
      sequential_training_enabled: new FormControl('')
    })
  }



  ngOnInit() {
    // console.log("modaldata mail data", this.modaldata);
    if (this.trainingsettingsForm.value) {
    }
    if (this.modaldata.trainingObj.sequential_training_enabled == 1) {
      this.trainingsettingsForm.setValue({ sequential_training_enabled: true });
      // console.log("trainingsettingsForm", this.trainingsettingsForm);
    } else {
      this.trainingsettingsForm.setValue({ sequential_training_enabled: false });
    }

  }

  trainingsettings() {
    if (this.trainingsettingsForm.valid) {
      let dataobj = {
        _id: this.modaldata.trainingObj._id,
        sequential_training_enabled: this.trainingsettingsForm.value.sequential_training_enabled
      }

      this.apiservice.getHttpDataPost('user/update-user', dataobj).subscribe((response) => {
        // console.log("response======++++", response);
        if (response.status == "success") {
          this.matSnackBar.open(response.message, "", {
            duration: 3000
          });
          this.dialogRef.close();
        }

      })

      // console.log("trainingsettingsForm", this.trainingsettingsForm.value)
      this.loader = true;
      // console.log("loader", this.loader);
    }
  }

  public closeModal() {
    this.dialogRef.close();
  }


  // public sendMail() {
  //   let dataobj = {
  //     _id: this.modaldata.mailObj._id
  //   }
  //   this.apiservice.getHttpDataPost('user/resend-welcome-mail', dataobj).subscribe((response) => {
  //     console.log("response======++++", response);
  //     if (response.status == "success") {
  //       this.matSnackBar.open(response.message, "", {
  //         duration: 3000
  //       });
  //       this.dialogRef.close();
  //     }

  //   })
  // }

}




@Component({
  selector: 'MarkAsGraduateModal',
  templateUrl: 'mark_as_graduate.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, SharedModule],
})
export class MarkAsGraduateModal {
  public userformdata: any = {};

  public roleList: any = [];
  public formfieldrefreshdata: any = null;
  public modaldata: any = {};
  public loader: boolean = false

  constructor(
    public dialogRef: MatDialogRef<MarkAsGraduateModal>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private apiservice: ApiservicesService, public matSnackBar: MatSnackBar
  ) {
    this.modaldata = data
    // console.log(this.modaldata.mailObj, "modal data++");
  }

  ngOnInit() {
    console.log("modaldata mail data", this.modaldata);
  }

  public closeModal() {
    this.dialogRef.close();
  }
  public sendMail() {
    let dataobj = {
      _id: this.modaldata.markasObj._id
    }
    this.apiservice.getHttpDataPost('user/mark-as-graduate-mail', dataobj).subscribe((response) => {
      // console.log("response======++++", response);
      if (response.status == "success") {
        this.matSnackBar.open(response.message, "", {
          duration: 3000
        });
        this.dialogRef.close();
      }

    })
  }




  // this.formfieldrefreshdata = {}
}



